// extracted by mini-css-extract-plugin
export default {"history_container":"HistoryList_history_container__5aFDD","history_item":"HistoryList_history_item__6W1Ib"};